import type User from '@this/domain/user/user';
import TravelerList from '@this/domain/traveler/traveler_list';
import Traveler from '@this/domain/traveler/traveler';

/**
 * 検索結果サマリーデータから旅程説明文を生成
 */
export const createItineraryDescription = (summaryData: { [key: string]: string }): string => {
  return Object.keys(summaryData)
    .map(key => `${key}: ${summaryData[key]}`)
    .join('\n');
};

/**
 * 初期出張者リストを生成
 */
export const createInitialTravelers = (peoplenum: number, user: User, members: User[]): TravelerList => {
  const travelers = TravelerList.fromCount(peoplenum);
  travelers.setTravelerAtIndex(0, new Traveler(user));

  if (peoplenum > 1) {
    for (let i = 1, end = peoplenum - 1, asc = end >= 1; asc ? i <= end : i >= end; asc ? (i += 1) : (i -= 1)) {
      if (user.show_other_members && members.length > 0) {
        travelers.setTravelerTypeAtIndex(i, 'member');
      } else {
        travelers.setTravelerTypeAtIndex(i, 'companion');
      }
    }
  }

  return travelers;
};
